import { abbreviateNumber } from 'js-abbreviation-number';

export const formatToUnits = (number: bigint | number): string => {
  return abbreviateNumber(Number(number), 1);
};
